import { CAMERA_PRESENTER, SCREEN_PRESENTER } from '@shoflo/polymer';
import {
  dismissAttendee,
  disableAttendeeScreenShare,
  removeDesiredAttendeeCamera
} from 'actions/Broadcast';
import { withCurrentParams } from 'actions/utils';
import { BROADCAST_UPDATE_SOURCE } from 'actions/Types';
import { UNASSIGNED, EMPTY_THUMBNAIL } from 'utils/broadcastSourceHelper';
import { VENDOR_AGORA } from '@studio/constants/Vendor';

/**
 * @param {string} sourceId
 * @param {object} [options]

 */
export default (sourceId, options = {}) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState) => {
      const { broadcastSources } = getState();

      const source = broadcastSources.sources.find(s => s._id === sourceId);

      const changes = {
        value: UNASSIGNED,
        thumbnail: EMPTY_THUMBNAIL
      };

      const useAgora = options.vendor === VENDOR_AGORA;
      const action = {
        type: BROADCAST_UPDATE_SOURCE,
        params: { sourceId },
        request: async apiClient => {
          const updatedSource = await apiClient.broadcast.updateSource(
            teamId,
            eventId,
            broadcastId,
            sourceId,
            changes
          );

          if (source.type === CAMERA_PRESENTER) {
            dispatch(dismissAttendee(source.value));
            dispatch(removeDesiredAttendeeCamera(source.value));
            const hasScreenShareSource = broadcastSources.sources.find(
              s => s.value === `${source.value}#content`
            );
            if (hasScreenShareSource && !useAgora) {
              dispatch(disableAttendeeScreenShare(source));
            }
          }

          if (source.type === SCREEN_PRESENTER && !useAgora) {
            const cameraSourceAttendeeId = source.value.replace('#content', '');
            const cameraSource = broadcastSources.sources.find(
              s => s.value === cameraSourceAttendeeId
            );

            if (cameraSource) {
              dispatch(disableAttendeeScreenShare(cameraSource));
            }
          }
          return {
            ...updatedSource,
            isInitializing: false
          };
        }
      };
      dispatch(action);
    }
  );
};
